import React from 'react';
import { useReveal } from '../lib/useReveal';
const FEATURES = ['Descargable', 'Digital', 'Entrega inmediata', 'Incluido sin costo adicional'];
export function CertificateSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#0a0e1f] py-5 md:py-10 px-5 sm:px-6 border-t border-[#ffffff]/5" data-id="element-44">
      <div className="container mx-auto max-w-4xl" data-id="element-45">
        <div ref={ref} className={`reveal bg-gradient-to-br from-[#1a1f3d] to-[#11152e] border border-[#d4af37]/30 rounded-3xl p-8 md:p-14 text-center shadow-md relative overflow-hidden ${vis ? 'is-visible' : ''}`} data-id="element-46">
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#d4af37]/10 rounded-full blur-3xl" data-id="element-47"></div>
          <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-[#4338ca]/15 rounded-full blur-3xl" data-id="element-48"></div>

          <div className="relative z-10" data-id="element-49">
            <div className="inline-flex items-center justify-center mb-6" data-id="element-50">
              <div className="relative" data-id="element-51">
                <div className="w-20 h-20 rounded-full bg-[#d4af37]/10 border-2 border-[#d4af37]/30 flex items-center justify-center" data-id="element-52">
                  <span className="text-4xl" data-id="element-53">🎓</span>
                </div>
              </div>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6] mb-5" data-id="element-54">
              Certificado digital incluido
            </h2>

            <p className="text-[#cbd0e0] text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-55">
              Recibí tu certificado digital junto con todo el contenido de la
              formación.
            </p>

            <div className="flex flex-wrap justify-center gap-3" data-id="element-56">
              {FEATURES.map((feature, i) => <div key={i} className="inline-flex items-center gap-2 bg-[#0a0e1f]/70 border border-[#d4af37]/20 rounded-full px-4 py-2 shadow-sm" data-id="element-57">
                  <span className="text-[#d4af37] font-bold" data-id="element-58">✓</span>
                  <span className="text-[#cbd0e0] text-sm font-semibold" data-id="element-59">
                    {feature}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}